import { COMPARISON_CATEGORIES } from '../../../../../utils/constants';

/**
 * Determines if a comparison category is a risk category that uses risk periods
 * @param categoryKey - The comparison category key
 * @returns true if the category is a risk category
 */
export const isRiskCategory = (categoryKey: string): boolean =>
  ([COMPARISON_CATEGORIES.ADVANCED_RISK_METRICS, COMPARISON_CATEGORIES.RISK_METRICS] as string[]).includes(categoryKey);

/**
 * Determines if a comparison category is a calendar year category
 * @param categoryKey - The comparison category key
 * @returns true if the category is a calendar year category
 */
export const isCalendarYearCategory = (categoryKey: string): boolean => COMPARISON_CATEGORIES.CALENDAR_YEAR_RETURNS === categoryKey;
